<speech-search-result *ngFor="let result of shownResults" [result]="result" [videoId]="videoId" [query]="query">
</speech-search-result>

<a *ngIf="results.length > maxShownByDefault" class="speech-search-results-list-expander" (click)="toggleExpansion()" [attr.aria-label]="(isExpanded ? 'ShowLess' : 'ShowMore' ) | translate">
	{{ ( isExpanded ? "Less" : "More" ) | translate }}
	<span class="glyphicons" [ngClass]="{ plus: !isExpanded, minus: isExpanded}" aria-hidden="true"></span>
</a>
